import * as initActions from './init'
import * as fileViewerActions from './fileViewer'
import * as commonActions from './common'
import * as progressActions from 'js-core/store/actions/progress'

export default {
    ...initActions,
    ...fileViewerActions,
    ...commonActions,
    ...progressActions
}
